import DateTime from "utils/dateTime"
export const createInstallmentDateKey = ({ index, frequencyTypeInstallment, startDate }) =>
  frequencyTypeInstallment === "bi_annually"
    ? DateTime.getDateAndTime(DateTime.getMonthsAfterDateProvided(startDate, index * 6))
    : DateTime.getDateAndTime(
        frequencyTypeInstallment === "quarterly"
          ? DateTime.getQuarterYearAfterDateProvided(startDate, index)
          : DateTime.getMonthsAfterDateProvided(startDate, index)
      )

export const createBalloonDateKey = ({ index, frequencyTypeBalloon, balloonDate }) =>
  frequencyTypeBalloon === "annually"
    ? DateTime.getMonthsAfterDateProvided(balloonDate, (index || 1) * 12)
    : frequencyTypeBalloon === "bi_annually"
    ? DateTime.getMonthsAfterDateProvided(balloonDate, (index || 1) * 6)
    : DateTime.getMonthsAfterDateProvided(balloonDate, (index || 1) * 3)

export const createDateTimeStamp = date => {
  let validDate = DateTime.getDateAndTime(date)
  if (!DateTime.isValidDate(validDate)) return DateTime.currentTime()
  return DateTime.convertDateToUnixTimeStamp(DateTime.getStartOfMonth(date))
}

export const roundPrice = price => {
  if (!price) return 0
  return Math.round(price)
}
